<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0" role="tabpanel" style="height: 500px;">
        <div class="row">
            <div class="col-md-12 m-t-5">
                <div class="ml-auto d-flex no-block align-items-center float-right">
                    <div class="dl">
                        <div class="button-group">
                            <a class="btn btn-success waves-effect waves-light text-white" data-target="#attachmentModal" data-toggle="modal">
                                <i class="fas fa-plus"></i> Add Attachment
                            </a>
                        </div>
                    </div>
                </div>

                <!-- MODAL FOR CONFIRMATION -->
                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModalForDelAttachment" role="dialog" tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-body card-blue">
                                <div class="text-center m-t-20 m-b-10">
                                    <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                    <br><br>
                                    <h4>Are you sure you want to remove this payment term?</h4>
                                    <button @click="deleteFile(docid, filepath)" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                                    <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- MODAL FOR ADDING ATTACHMENT -->
                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="attachmentModal" role="dialog" tabindex="-1">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <form @submit.prevent="handleSubmit">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="attachmentModalLabel">Add Attachment</h4>
                                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                                </div>
                                <div class="modal-body card-blue">
                                    <div class="card-body">
                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <input :class="{'is-invalid': submitted && errors.has('file_title')}"
                                                       class="form-control"
                                                       id="file_title"
                                                       name="file_title"
                                                       placeholder="Title"
                                                       style="height: 42px;"
                                                       type="text"
                                                       v-model="fileTitle"
                                                       v-validate="'required'">
                                                <div class="invalid-feedback" v-if="submitted && errors.has('file_title')">{{ errors.first('file_title') }}</div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <textarea
                                                        class="form-control"
                                                        data-vv-as="description"
                                                        id="description"
                                                        name="description"
                                                        placeholder="File Description"
                                                        rows=3
                                                        v-model="fileDesc">
                                                </textarea>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="input-group col-md-8">
                                                <div class="custom-file">
                                                    <input :class="{'is-invalid': submitted && errors.has('file')}"
                                                           @change="onFileChange"
                                                           class="custom-file-input"
                                                           id="file"
                                                           name="file"
                                                           ref="file"
                                                           type="file"
                                                           v-validate="'required'">
                                                    <div class="invalid-feedback" v-if="submitted && errors.has('file')">{{ errors.first('file') }}</div>
                                                    <label class="custom-file-label" for="file" style="cursor: pointer">{{filename}}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-success" type="submit">Submit</button>
                                    <button class="btn btn-secondary" type="button">Reset</button>
                                    <button class="btn btn-danger" data-dismiss="modal" type="button">Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- TABLE FOR ADDED ATTACHMENT -->
                <div class="col-md-12 m-t-20" v-if="contract.attachments.length > 0">
                    <div class="table-responsive p-t-25">
                        <table class="table no-wrap v-middle">
                            <thead>
                            <tr class="border-0">
                                <th class="border-0"><h6>#</h6></th>
                                <th class="border-0"><h6>File Name</h6></th>
                                <th class="border-0"><h6>Title</h6></th>
                                <th class="border-0"><h6>Description</h6></th>
                                <th class="border-0"><h6>Action</h6></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-bind:key="index" v-for="(a, index) in contract.attachments">
                                <td>{{index+1}}</td>
                                <td>{{a.filename}}</td>
                                <td>{{a.title}}</td>
                                <td>{{a.desc | truncate(30, '...')}}</td>
                                <td>
                                    <a @click="setRemoveProps(a.id, a.filepath)"
                                       class="text-danger"
                                       data-target="#confirmModalForDelAttachment"
                                       data-toggle="modal" href="javasript:void(0);">
                                        <b>Remove</b>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from "vuex";
    import axios from 'axios';
    import uuid from "uuid/v4";

    export default {
        name: "Attachment",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            })
        },
        data() {
            return {
                submitted: false,
                isForward: false,
                contractid: null,
                uploadstatus: '',
                docid: null,
                file: null,
                filename: "Upload Attachment",
                filepath: null,
                fileTitle: '',
                fileDesc: '',
                contract: this.$parent.contract
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                this.contractid = uuid();
            },
            async onFileChange(e) {
                this.file     = this.$refs.file.files[0];
                this.filename = this.file.name;
            },
            async handleSubmit() {
                this.submitted = true;
                try {
                    let valid = await this.$validator.validate();
                    if(valid) {
                        this.submitted = false;
                        this.uploadFile();
                    }
                } catch(e) {
                    console.error(e);
                }
            },
            async uploadFile() {
                this.uploadstatus = "Uploading File Please Wait";
                let signedurl     = await this.getUploadUrl();
                await axios.put(signedurl, this.file);
                this.resetAttachment();
                $("#attachmentModal").modal('toggle');
            },
            async getUploadUrl() {
                $(".preloader").fadeIn();
                let signedUrl = await this.$http.get(`/express/${this.currentOrg.express_id}/contracts/signedurl`, {
                    params: {
                        name: this.filename,
                        type: 'write'
                    }
                });
                $(".preloader").fadeOut();

                let parts = this.filename.split(".");
                this.contract.attachments.push({
                    filename: this.filename,
                    title: this.fileTitle,
                    desc: this.fileDesc,
                    filepath: signedUrl.data.key,
                    contenttype: parts[parts.length - 1]
                });

                return signedUrl.data.url;
            },
            setRemoveProps(docid, filepath) {
                this.docid    = docid;
                this.filepath = filepath;
            },
            async deleteFile(id, filepath) {
                $(".preloader").fadeIn();
                await this.$http.delete(`/express/${this.currentOrg.express_id}/contracts/attachments`, {
                    data: {
                        contractid: this.contractid,
                        filepath: filepath
                    }
                });
                _.remove(this.contract.attachments, function(a) {
                    return a.id == id;
                });
                this.contract.attachments = JSON.parse(JSON.stringify(this.contract.attachments));
                $(".preloader").fadeOut();
                this.resetAttachment();
                this.$toastr('success', 'Attachment deleted successfully', 'Success');
            },
            resetAttachment() {
                this.file      = File;
                this.filename  = "Upload Attachment";
                this.fileTitle = "";
                this.fileDesc  = "";
            },
        }
    }
</script>

<style scoped>

</style>
